import React from "react";
import { languageHelper } from "../../config/helperFunctions";

function DeleteModal({ setIsOpen, onDelete }) {
  return (
    <div
      className="w-full h-screen overflow-y-auto grid place-items-center fixed top-0 left-0 bg-black bg-opacity-50 backdrop-blur-md p-4 z-10"
      onClick={() => setIsOpen(false)}
    >
      <div
        className="p-4 rounded-lg bg-white max-w-md w-full space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="space-y-4">
          <h1 className="text-d-bg-text font-semibold text-xl text-center">
            {languageHelper("Alert!") || "Alert!"}
          </h1>
          <p className="text-center text-gray-700">
            {languageHelper("Are you sure?")}
          </p>
        </div>
        <div className="flex justify-center gap-4">
          <button
            className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
            onClick={() => setIsOpen(false)}
          >
            {languageHelper("No") || "No"}
          </button>
          <button
            onClick={() => {
              onDelete();
              setIsOpen(false);
            }}
            className="bg-d-cat-btn text-white font-bold text-sm px-4 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center"
          >
            {languageHelper("Yes") || "Yes"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteModal;
